import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function DynamicTestimonial({aiData}) {
if (!aiData?.testimonials) return null;

    const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "18%",
    autoplay: true,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
        },
      },
    ],
  };
const testimonials = aiData?.testimonials?.items || [];

  return (
<>
  <section className="dynamic-testimonial-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7 dynamic-testimonial-heading text-center">
            <span className="main-title">{aiData?.testimonials?.eyebrow}</span>
            <h2 className="heading">{aiData?.testimonials?.title}</h2>
          </div>
        </div>
      </div>

      <div className="dynamic-testimonial-slider">
        <Slider {...settings}>
          {testimonials.map((item, index) => (
            <div className="dynamic-testimonial-slide" key={index} >
              <div className="dynamic-testimonial-card">
                <div className="dynamic-testimonial-quote">“</div>
                <div className="dynamic-testimonial-text" dangerouslySetInnerHTML={{ __html: item?.content}}/>
                <div className="dynamic-testimonial-author">
                  <div className="dynamic-testimonial-author-content">
                    <h4 className="dynamic-testimonial-author-name"> {item?.authorName}  </h4>
                    <div className="dynamic-testimonial-designation" dangerouslySetInnerHTML={{ __html: item?.authorDesignation}}/>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
</>
  )
}
